import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

import { environment } from 'src/environments/environment';
import { environment as qa } from '../../environments/environment.qa';
import { environment as dev } from '../../environments/environment.dev';
import { environment as stage } from '../../environments/environment.stage';
import { environment as prd } from '../../environments/environment.prod';
import { Subject } from 'rxjs';

@Injectable()
export class AppService {

  //-- VARIABLES -------------------------------------------------------|

  readonly ENV: any = environment;

  //-- CONSTRUCTOR -----------------------------------------------------|

  constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: Object) {

    switch (window['env']) {
      case 'dev': this.ENV = dev; break;
      case 'stg': this.ENV = stage; break;
      case 'qa': this.ENV = qa; break;
      case 'prd': this.ENV = prd; break;
    }
  }
  
  //-- LOADING STATUS --------------------------------------------------|

  private loadingStatus: boolean = true;
  private _loadingStatus = new Subject<boolean>();
  $loadingStatus = this._loadingStatus.asObservable();

  getLoadingStatus() { return this.loadingStatus; }

  setLoadingStatus(val: boolean) {
    this.loadingStatus = val;
    this._loadingStatus.next(val);
  }

  //-- ROUTING ---------------------------------------------------------|

  public _REGISTER: number = 0;
  public _OFFER: number = 2;
  public _INELIGIBLE: number = 3;
  public _ERROR: number = 4;
  public _ENDED: number = 5;
  public _CONFIRM: number = 6;
  public _INCORRECT: number = 7;
  public _ALREADY: number = 8;

  redirectTo(val: number) {

    let routeName: string = '';

    switch (val) {
      case 0: routeName = 'register'; break;
      case 2: routeName = 'offer'; break;
      case 3: routeName = 'ineligible'; break;
      case 4: routeName = 'error'; break;
      case 5: routeName = 'ended'; break;
      case 6: routeName = 'confirm'; break;
      case 7: routeName = 'incorrect'; break;
      case 8: routeName = 'enrolled'; break;
    }

    if (routeName != '') {
      this.router.navigate([routeName]);
    }
  }

  scrollTop() {
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe((event: NavigationEnd) => { window.scroll(0, 0); });
    }
  }

  private cookieButtonHandler(event) {
    event.preventDefault();
    
    const cookieModal = document.getElementById('cmp-revokie-consent');
    if (cookieModal) {
      cookieModal.click();
    }
  }

  addClickEvent() {
    setTimeout(() => {
      document.querySelectorAll('.cookie-consent').forEach((cookieButton) => {
        cookieButton.addEventListener('click', this.cookieButtonHandler);
      });
    }, 0); // Wait for the DOM to be ready 
    
  }

  //--------------------------------------------------------------------|

}
